import { Loader2 } from 'lucide-react';
import { MoneyValue } from '../MoneyValue';

/**
 * The "Total tagihan" figure. `null` means the amount for the chosen tender is
 * still being priced — shown as such, never as Rp 0 or as the cart's
 * placeholder-priced total (see `lib/amountDue`).
 */
export function AmountDue({ value }: { value: number | null }) {
  if (value === null) {
    return (
      <span className="flex h-9 items-center justify-center gap-2 text-sm text-ink-400">
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> menghitung…
      </span>
    );
  }
  return <MoneyValue value={value} emphasis className="text-3xl" />;
}
